import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid'
import type { IconComponent } from '../../../types/icon'

interface StatCardProps {
  name: string
  value: string | number
  change?: {
    value: string
    type: 'increase' | 'decrease' | 'neutral'
  }
  icon?: IconComponent
  loading?: boolean
}

export default function StatCard({
  name,
  value,
  change,
  icon: Icon,
  loading = false,
}: StatCardProps) {
  if (loading) {
    return (
      <div className="card">
        <div className="card-body">
          <div className="animate-pulse">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="h-8 w-8 bg-gray-200 rounded"></div>
              </div>
              <div className="ml-5 w-0 flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-6 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const getChangeColor = () => {
    switch (change?.type) {
      case 'increase':
        return 'text-green-600'
      case 'decrease':
        return 'text-red-600'
      default:
        return 'text-gray-500'
    }
  }

  const getChangeIcon = () => {
    switch (change?.type) {
      case 'increase':
        return ArrowUpIcon
      case 'decrease':
        return ArrowDownIcon
      default:
        return null
    }
  }

  const ChangeIcon = getChangeIcon()

  return (
    <div className="card">
      <div className="card-body">
        <div className="flex items-center">
          <div className="flex-shrink-0">{Icon && <Icon className="h-8 w-8 text-gray-400" />}</div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">{name}</dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-semibold text-gray-900">
                  {typeof value === 'number' ? value.toLocaleString() : value}
                </div>
                {change && (
                  <div
                    className={`ml-2 flex items-baseline text-sm font-semibold ${getChangeColor()}`}
                  >
                    {ChangeIcon && <ChangeIcon className="h-4 w-4 mr-1" />}
                    {change.value}
                  </div>
                )}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}
